import { __module as t } from "./ghl-ui.es1735.js";
import { i as c } from "./ghl-ui.es1541.js";
import { b as w } from "./ghl-ui.es1736.js";
(function(o, a) {
  var d = c.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var n = d(w), u = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, m = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, g = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, l = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, h = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, f = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, v = function(r, y) {
    var e = Number(r), i = e % 100;
    if (i > 20 || i < 10)
      switch (i % 10) {
        case 1:
          return e + "st";
        case 2:
          return e + "nd";
        case 3:
          return e + "rd";
      }
    return e + "th";
  }, s = {
    ordinalNumber: v,
    era: (0, n.default)({
      values: u,
      defaultWidth: "wide"
    }),
    quarter: (0, n.default)({
      values: m,
      defaultWidth: "wide",
      argumentCallback: function(r) {
        return r - 1;
      }
    }),
    month: (0, n.default)({
      values: g,
      defaultWidth: "wide"
    }),
    day: (0, n.default)({
      values: l,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, n.default)({
      values: h,
      defaultWidth: "wide",
      formattingValues: f,
      defaultFormattingWidth: "wide"
    })
  }, b = s;
  a.default = b, o.exports = a.default;
})(t, t.exports);
var W = t.exports;
export {
  W as l
};
